module.exports = __webpack_public_path__ + "img/weather02.1728a67c.png";